import { createMap } from './createMap.js';
import { fitBounds } from './functions/fitBounds.js';
import { flyTo } from './functions/flyTo.js';
import { hasLayer, listLayers } from './functions/layers.js';
import { getObject, hasObject, listObjects } from './functions/objects.js';
import { defineSprite, getSprite, hasSprite, listSprites, } from './functions/sprite.js';
import { addGeojson } from './objects/geojson.js';
import { addMarker } from './objects/marker.js';
import { addPopup } from './objects/popup.js';
import { onEvent } from './onEvent.js';
export function getLib() {
    return {
        createMap,
        getObject,
        hasObject,
        listObjects,
        hasLayer,
        listLayers,
        addGeojson,
        addMarker,
        addPopup,
        hasSprite,
        getSprite,
        listSprites,
        defineSprite,
        onEvent,
        fitBounds,
        flyTo,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGliLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbImxpYi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sZ0JBQWdCLENBQUE7QUFDMUMsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLDBCQUEwQixDQUFBO0FBQ3BELE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQTtBQUM1QyxPQUFPLEVBQUUsUUFBUSxFQUFFLFVBQVUsRUFBRSxNQUFNLHVCQUF1QixDQUFBO0FBQzVELE9BQU8sRUFBRSxTQUFTLEVBQUUsU0FBUyxFQUFFLFdBQVcsRUFBRSxNQUFNLHdCQUF3QixDQUFBO0FBQzFFLE9BQU8sRUFDTixZQUFZLEVBQ1osU0FBUyxFQUNULFNBQVMsRUFDVCxXQUFXLEdBQ1gsTUFBTSx1QkFBdUIsQ0FBQTtBQUM5QixPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sc0JBQXNCLENBQUE7QUFDakQsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLHFCQUFxQixDQUFBO0FBQy9DLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQTtBQUM3QyxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sY0FBYyxDQUFBO0FBR3RDLE1BQU0sVUFBVSxNQUFNO0lBQ3JCLE9BQU87UUFDTixTQUFTO1FBRVQsU0FBUztRQUNULFNBQVM7UUFDVCxXQUFXO1FBRVgsUUFBUTtRQUNSLFVBQVU7UUFFVixVQUFVO1FBQ1YsU0FBUztRQUNULFFBQVE7UUFFUixTQUFTO1FBQ1QsU0FBUztRQUNULFdBQVc7UUFDWCxZQUFZO1FBRVosT0FBTztRQUVQLFNBQVM7UUFDVCxLQUFLO0tBQ0wsQ0FBQTtBQUNGLENBQUMifQ==